'use client';

import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { Hits } from 'react-instantsearch-next';

const AdvancedSearchProductHits = () => <Hits />;

export default AdvancedSearchProductHits;
